<template>
  <section class="report-year">
    <error-alert v-if="$store.getters.errorMessageWithReportYear" />
    <template v-else>
      <sheet-year
        :stockSymbol="$store.getters.headlinesOfReportYear.stockSymbol"
        :companyName="$store.getters.headlinesOfReportYear.companyName"
        :headline="$store.getters.headlinesOfReportYear.balanceSheetsYear"
        :unitOfTime="'年'"
        :unitOfNumber="'百萬'"
        :fields="fieldsOfBalanceSheetsYear"
        :items="$store.getters.layerOfBalanceSheetsYear"
      />
      <sheet-year
        :stockSymbol="$store.getters.headlinesOfReportYear.stockSymbol"
        :companyName="$store.getters.headlinesOfReportYear.companyName"
        :headline="$store.getters.headlinesOfReportYear.incomeStatementsYear"
        :unitOfTime="'年'"
        :unitOfNumber="'百萬'"
        :fields="fieldsOfIncomeStatementsYear"
        :items="$store.getters.itemsOfIncomeStatementsYear"
      />
      <sheet-year
        :stockSymbol="$store.getters.headlinesOfReportYear.stockSymbol"
        :companyName="$store.getters.headlinesOfReportYear.companyName"
        :headline="$store.getters.headlinesOfReportYear.cashFlowStatementsYear"
        :unitOfTime="'年'"
        :unitOfNumber="'百萬'"
        :fields="fieldsOfCashFlowStatementsYear"
        :items="$store.getters.layerOfCashFlowStatementsYear"
      />
    </template>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import mixins from "@/utility/mixins.js";
import SheetYear from "@/components/SheetYear.vue";
import ErrorAlert from "@/components/ErrorAlert.vue";

export default {
  name: "ReportYear",
  mixins: [mixins],
  components: {
    SheetYear,
    ErrorAlert
  },
  beforeRouteUpdate(to, from, next) {
    this.$store.dispatch("FETCH_REPORT_YEAR");
    next();
  },
  computed: {
    ...mapGetters([
      "balanceSheetsYear",
      "incomeStatementsYear",
      "cashFlowStatementsYear"
    ]),
    fieldsOfBalanceSheetsYear() {
      return this.fieldsOfYear(this.balanceSheetsYear);
    },
    fieldsOfIncomeStatementsYear() {
      return this.fieldsOfYear(this.incomeStatementsYear);
    },
    fieldsOfCashFlowStatementsYear() {
      return this.fieldsOfYear(this.cashFlowStatementsYear);
    }
  }
};
</script>

<style scoped lang="scss">
::v-deep caption {
  padding-bottom: 0;
}
::v-deep .table-hover tbody tr:hover {
  background-color: #343a40;
  color: #fff;
}
</style>
